import { useEffect, useContext, useMemo, useState } from 'react';
import { format } from 'date-fns';
import { useRemote } from '../../../Utils/Utils';
import { BannerContext } from '../../../InternalApiApp';
import AnalyticsHeader from './AnalyticsHeader';
import LoadingIcon from '../../Shared/LoadingIcon';
import { analyticsExportFilename } from '../AnalyticsUtils';
import moment from 'moment';

const DataPoint = ({ label, mb, endpoint,dataLabel, customeDate }) => {
    const remote = useRemote();
    const end = format(new Date(), 'yyyy-MM-dd');
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([]);
    const { bannerAdditionalInfo } = useContext(BannerContext)

    useEffect(() => {
        console.log('DataPoint useEffect called')
        const products = bannerAdditionalInfo?.platforms.map(platform =>
            platform.products.map(p => p.selected ? `product=${p.id}` : null)
                .filter(e => e !== null)
                .join("&")
        )

        const productsParam = products ? `&${products}` : '';

        if (bannerAdditionalInfo && customeDate && customeDate.from && customeDate.to && endpoint) {
            setLoading(true);
            const end = moment(customeDate.to).format('YYYY-MM-DD');
            const start = moment(customeDate.from).format('YYYY-MM-DD');
            const endpoint1 = endpoint.replace('${start}', start).replace('${end}', end).replace('${products}', productsParam);
            const promise1 = remote.get(endpoint1)
            Promise.all([promise1]).then(([currentPeriodData]) => {
                console.log('DataPoint fetched currentPeriodData:', Array.isArray(currentPeriodData))
                        const data1 =  [{ 'value': currentPeriodData }];
                        const formattedData1 =  { ...data1[0], label: `${dataLabel}` };

                        setData({ current: formattedData1 })
                        console.log('DataPoint resp:', { current: formattedData1 })
                        setLoading(false);
                    }).catch((error) => {
                        console.error('Error fetching DataPoint data:', error);
                        setLoading(false);
                    })
        }

    }, [bannerAdditionalInfo, endpoint, dataLabel, end, remote, customeDate]);

    console.log('DataPoint render data:', data.current)

    const exportHeaders = useMemo(() => [
        { label: 'Metric', key: 'metric' },
        { label: 'Value', key: 'value' },
    ], []);

    const exportData = useMemo(() => {
        if (!data || !data.current) return [];
        return [{ metric: data.current.label, value: data.current.value }];
    }, [data]);

    const exportFilename = useMemo(
        () => analyticsExportFilename('backtracking-rate', customeDate),
        [customeDate]
    );

    return (
        <>
            <AnalyticsHeader
                mb={mb ? mb :'m'}
                exportHeaders={exportHeaders}
                exportData={exportData}
                exportFilename={exportFilename}
                exportLoading={loading}
            >{label ? label : "Search Terms"}</AnalyticsHeader>
            <div style={{ display: 'flex', gap: '1rem' }} className='mt-s'>
                {!loading ? 
                        <>
                            <div style={{ display: 'flex', gap: '1rem' }} className={`${mb ? `mb-${mb}` : ''}`}>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', gap: '0.25rem',
                                    padding: "0.5rem", borderRadius: "0.25rem"
                                }}>
                                    <div style={{ color: "#333B5A" }} className='font-size-body-xs'>{data.current?.label}</div>
                                    <div className='font-size-header-3 font-weight-medium'>{data.current?.value.toFixed(1)}</div>
                                </div>
                            </div>
                        </>
                    : <LoadingIcon centered/>
                }
            </div>
        </>
    );
}

export default DataPoint;